//replaces barchart.html
import type { FC } from "react";

import { NgToReactChart } from "app/components/React/NgToReactChart/NgToReactChart";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

export const BarChartTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    return !widget.viewOptions.isMobileOrDesktopOnly || widget.apiParams.webSource === "Total" ? (
        <div
            style={{ position: "relative" }}
            className={`chartContainer ${widget.viewOptions.cssClass}`}
        >
            <NgToReactChart highchartsNgConfig={widget.chartConfig} />
        </div>
    ) : null;
};
